window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

require('./web_function')
require('./validation_helper')
$(function () {

    observeForm('#rd-form', {
            ignore: ['.note-editor *'],
            rules: {
                first_name: {required: true},
                surname   : {required: true},
                email     : {required: true, email:true},
                company   : {required: true},
                message   : {required: true},
            }
        }
        , function (form) {
            $('#rd-loading').show()
            form.submit();
        });

    let target = $('meta[name="target"]').attr('content')

    if(target){

        switch (target) {
            case 'partnerships':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-3", offsetY: 0 } });
                break;

            case 'career':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-4", offsetY: 0 } });
                break;
        }
    }

})

